export default __webpack_public_path__ + "static/media/trophySvg.3f58c9d9.svg";